import React from 'react';

export const NoWorriesStep: React.FC = () => {
  return (
    <div className='w-full h-full min-h-[400px] flex flex-col items-center gap-16 px-16 sm:py-16'>
      <div className='flex flex-col gap-4'>
        <h2 className='text-2xl font-bold'>
          We get it. This is frustrating.
        </h2>
        <div>
          It’s not the outcome we were both hoping for but there is still some good news. While you weren’t approved for a health plan this round, we can still offer you some real protection paths. We can help you build a health safety net you can use right away with these plans:
        </div>
        <ul className='list-disc list-inside space-y-2'>
          <li><b>Dental & Vision</b> – for cleanings, fillings, glasses, contacts.</li>
          <li><b>Accident & Hospital Indemnity</b> – for cash benefits that help with medical bills, travel, and time off work.</li>
          <li><b>Critical Illness</b> – for a lump-sum payout if something serious happens.</li>
        </ul>
        <div>
          If you would like to browse these plans and learn how they can offer real protection at a reasonable cost, just click the <b>Next</b> button.
        </div>
        <div>
          <b>The upside: </b>you can still shop our other plans today. If things change, you can reapply for health coverage in 90 days—no problem.
        </div>
      </div>
    </div>
    // <img
    //   src="/images/coverage.png"
    //   alt="Coverage illustration"
    //   className="w-full h-full object-cover object-right-top"
    // />
  );
};
